import { track } from '../../analytics/events';

export const desktopAnalytics = () => ({
  // top level click events
  click: {
    autofillBannerDismissed: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'autofill-banner',
      },
    }),
    autofillClicked: () => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'autofill-checkbox',
      },
    }),
    continueOffers: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'continue-offers',
      },
      actionOutcome: 'Submit',
    }),
    continueVR: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'continue-vr',
      },
      actionOutcome: 'Submit',
    }),
    continueReprompt: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'continue-for-reprompt',
      },
    }),
    offersNoVR: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'offers-no-vr',
      },
      actionOutcome: 'Submit',
    }),
  },
  // farewell modal events and events housed within
  farewellModal: {
    opened: () => track('ModalOpened', {
      webElement: {
        name: 'farewell',
      },
      actionOutcome: 'MODAL_OPENED',
    }),
    closed: () => track('ModalClosed', {
      webElement: {
        name: 'farewell',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    autofillClicked: () => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'exit-modal-opt-in',
      },
    }),
    noThanks: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'farewell-modal-no-thanks',
      },
      actionOutcome: 'Submit',
    }),
    continue: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'farewell-modal-continue',
      },
      actionOutcome: 'Submit',
    }),
  },
  // reprompt modal events and events housed within
  repromptModal: {
    opened: () => track('ModalOpened', {
      webElement: {
        name: 'Reprompt',
      },
      actionOutcome: 'MODAL_OPENED',
    }),
    closed: () => track('ModalClosed', {
      webElement: {
        name: 'Reprompt',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    autofillClicked: () => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'autofill-checkbox-reprompt',
      },
    }),
    continue: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue-Reprompt',
      },
      actionOutcome: 'Submit',
    }),
  },
});

export const mobileAnalytics = () => ({
  click: {
    autofillBannerDismissed: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'autofill-banner',
      },
    }),
    autofillClicked: () => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'autofill-checkbox',
      },
    }),
    continueOffers: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'continue-offers',
      },
      actionOutcome: 'Submit',
    }),
    continueVR: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'continue-vr',
      },
      actionOutcome: 'Submit',
    }),
    continueReprompt: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'continue-for-reprompt',
      },
    }),
    offersNoVR: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'offers-no-vr',
      },
      actionOutcome: 'Submit',
    }),
  },
  repromptModal: {
    opened: () => track('ModalOpened', {
      webElement: {
        name: 'Reprompt',
      },
      actionOutcome: 'MODAL_OPENED',
    }),
    closed: () => track('ModalClosed', {
      webElement: {
        name: 'Reprompt',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    autofillClicked: () => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'autofill-checkbox-reprompt',
      },
    }),
    continue: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue-Reprompt',
      },
      actionOutcome: 'Submit',
    }),
  },
});
